$(window).resize(function() {
  var $window_width = $('body').innerWidth();
  if ($window_width < 661) {
    $("#home .nav_item").click(function(){
        $("body").addClass("nav_expand");
    });
    $(".home_wrap_playlist .btn-back").click(function(){
        $("body").removeClass("nav_expand");
    });

    // $("#home .nav_item").removeClass("is_current");
    $(".post_wrap").removeClass("is_collapsed");
  }
  else {
    $("body").removeClass("nav_expand");
    $("#home .nav_item").click(function(){
        $("body").removeClass("nav_expand");
    });
    // if desktop, add is_current to the first child of the nav
    // if ($('.nav_item.is_current').length > 0) {
    //   $("#home .nav_item").first().addClass("is_current");
    //   $("#home .post_playlist_ul").hide();
    //   $("#home .post_playlist_ul").first().show();
    // }
  }
});
